
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12135',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12135",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.464",
  "dashboard-client-types": "static-1.359",
  "data-fetching-client": "static-1.9638",
  "foundations-components": "static-1.7856",
  "foundations-components-legacy": "static-1.881",
  "foundations-theming": "static-1.4382",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7980",
  "hub-http-shared-msw-handlers": "static-1.9872",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11427",
  "I18n": "static-7.1615",
  "jasmine-runner": "static-1.6433",
  "marketplace-storefront-base": "static-1.12196",
  "quartz": "static-1.6973",
  "react-dlb": "static-1.78",
  "react-rhumb": "static-1.16634",
  "reactive-variable-buffer-atom": "static-1.2824",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.55",
  "settings-ui-lib": "static-1.12486",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7065",
  "ui-addon-i18n": "static-1.11115",
  "ui-addon-react-router-dom": "static-1.9510",
  "unified-auth": "static-1.443",
  "unified-auth-core-lib": "static-1.724",
  "usage-tracker": "static-1.7303",
  "usage-tracker-core": "static-1.7153",
  "customer-data-property-utils": "static-1.8048",
  "hub-http": "static-1.6187",
  "integrations-lib": "static-1.16004",
  "marketplace-ui-common": "static-1.19584",
  "property-management-iframe": "static-1.13021",
  "quartz-config": "static-1.751",
  "quartz-core": "static-1.6192",
  "quartz-routing": "static-1.403",
  "quick-fetch": "static-1.3886",
  "react": "static-7.185",
  "rpc-client-utils": "static-1.4616",
  "ts-schema": "static-1.4048",
  "ui-universal-auth": "static-1.8929",
  "UIComponents": "static-3.8374",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3374",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3250",
  "quartz-webpack": "static-1.3197",
  "bend-plugin-quartz-routing": "static-1.51",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4125",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4823",
  "foundations-theming-specialty": "static-1.2098",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9394",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5314",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1743",
  "ui-fonts": "static-1.689",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-theming": "static-1.2865",
  "foundations-theming-base": "static-1.3367",
  "stylex": "static-1.32",
  "HeadJS": "static-2.742",
  "hs-test-utils-bend-plugin": "static-1.3091",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4289",
  "ai-components-ui-library": "static-1.8843",
  "ai-rendering-library": "static-1.9988",
  "chirp-fetch": "static-1.1850",
  "connections-embed-lib": "static-1.923",
  "copilot-toolkit": "static-1.11036",
  "feedback-loader": "static-1.29227",
  "laboratory-lib": "static-3.7124",
  "marketplace-embed": "static-1.21975",
  "marketplace-ui-details": "static-1.9480",
  "marketplace-ui-reviews": "static-1.19540",
  "marketplace-ui-tracking": "static-1.13755",
  "sanitize-text": "static-1.8108",
  "ui-addon-video-player": "static-1.8663",
  "usage-tracker-multi": "static-1.5717",
  "usage-tracker-session-replay": "static-1.4989",
  "wootric-nps": "static-1.6949",
  "quartz-head": "static-1.638",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4613",
  "immer": "static-1.33",
  "immerable": "static-1.4119",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2480",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.55",
  "cssUtils": "static-1.782",
  "flux-actions": "static-1.331",
  "HubStyle": "static-2.11735",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10176",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10336",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7293",
  "icons": "static-2.644",
  "marketplace-ui-apps-core": "static-1.18117",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4480",
  "foundations-components-test-utils": "static-1.5339",
  "quartz-i18n": "static-1.648",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.128",
  "microsoft-drive-integration-lib": "static-1.245",
  "fsm": "static-1.3697",
  "customer-data-objects": "static-1.7628",
  "property-translator": "static-1.5366",
  "hs-locale-management": "static-1.54",
  "frontend-preferences-client": "static-1.7894",
  "hs-promise-utils": "static-1.5558",
  "hubspot-apollo-client": "static-1.4841",
  "integrations-error-boundary-lib": "static-1.13419",
  "integrations-tracking-lib": "static-1.5564",
  "native-integrations-shared-strings": "static-1.7748",
  "reselect": "static-2.16",
  "sanitize": "static-1.4437",
  "superstore": "static-1.4731",
  "ui-shepherd-react": "static-3.10114",
  "ai-settings-ui-library": "static-1.7824",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4622",
  "immutable-less": "static-1.4614",
  "marketplace-ui-client-types": "static-1.16991",
  "nav-meta": "static-1.29544",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10211",
  "ui-addon-upgrades": "static-9.17934",
  "inbound-db-properties-service-client": "static-1.3810",
  "property-management-common": "static-1.5309",
  "ui-addon-iframeable": "static-1.9023",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.648",
  "quartz-test": "static-1.648",
  "quartz-tracking": "static-1.352",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.26",
  "bender-build-tools": "static-1.3151",
  "inbound-db-meta-service-client": "static-1.3560",
  "persist-promise": "static-1.3667",
  "reference-resolvers": "static-1.8135",
  "transmute": "static-2.85",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21116",
  "ContentUtils": "static-1.68252",
  "customer-data-objects-ui-components": "static-1.12991",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2464",
  "customer-data-filters-ui": "static-1.39628",
  "customer-data-reference-ui-components": "static-1.13125",
  "embedded-academy-lib": "static-1.14229",
  "ExportDialog": "static-6.10359",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41195",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.55",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.55",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.55",
  "ui-addon-teams": "static-1.21497",
  "magpie-lib": "static-1.5536",
  "navigation-components": "static-1.17907",
  "magpie-types": "static-1.4996",
  "simple-logging-lib": "static-1.3014",
  "ai-studio-lib": "static-1.11498",
  "app-governance-lib": "static-1.1431",
  "developer-experience-shared-components": "static-1.10475",
  "ui-addon-integrations-directory-panel": "static-2.7962",
  "ui-product-approvals": "static-1.28028",
  "ui-tool-access": "static-1.10115",
  "usage-based-billing-components-lib": "static-1.8698",
  "usage-tracker-anonymous": "static-1.5720",
  "usage-tracker-public": "static-1.7114",
  "amplitude-session-replay-browser": "static-1.59",
  "ui-extensibility-client-types": "static-1.3891",
  "hubspot-apollo-cache": "static-1.300",
  "universal-page-editor-lib": "static-1.2978",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2671",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5037",
  "purchase-motions-components": "static-1.5816",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1510",
  "crm-component-utils": "static-1.38986",
  "crm-properties-common-lib": "static-1.5841",
  "customer-data-properties": "static-1.51420",
  "framework-data-schema-resolvers": "static-1.6845",
  "property-value-citations": "static-1.2034",
  "reference-resolvers-lite": "static-1.8060",
  "navigation-messaging": "static-1.7234",
  "hubspotter-http-shared-msw-handlers": "static-1.9870",
  "growth-payments-core": "static-1.25268",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13565",
  "conversations-skeleton-state": "static-1.7214",
  "crm-message-bus": "static-1.42892",
  "reporting-plugins": "static-1.10255",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.55",
  "cms-field-types": "static-1.4777",
  "content-icons-ui": "static-1.2216",
  "customer-data-ui-utilities": "static-1.9792",
  "customer-data-filters-ui-msw-helpers": "static-1.22063",
  "FormUrlGenerator": "static-2.4684",
  "framework-builder-read-service-client": "static-1.3979",
  "framework-data-schema-quick-fetch": "static-1.6750",
  "multi-account-reference-resolvers": "static-1.944",
  "onboarding-tours": "static-1.16526",
  "academy-common-lib": "static-1.13689",
  "content-assistance-lib": "static-1.7694",
  "dashboard-lib": "static-1.81385",
  "file-manager-components": "static-1.23514",
  "getting-started-shared-tasks": "static-1.18399",
  "hubspot-prosemirror": "static-1.18139",
  "hubspot-prosemirror-plugins": "static-1.18131",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19766",
  "share-with-third-party-component-lib": "static-1.8663",
  "ui-addon-draggable": "static-3.4734",
  "ui-asset-management-lib": "static-1.10976",
  "ui-business-units-lib": "static-1.9014",
  "user-context": "static-1.5068",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.686",
  "nest": "static-1.192",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10589",
  "framework-listing-lib": "static-2.28587",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30628",
  "apps-service-types": "static-1.3843",
  "oauth-service-types": "static-1.4216",
  "onboarding-scopes": "static-1.6427",
  "onboarding-tours-client": "static-1.4740",
  "platform-infra-nav-components": "static-1.7643",
  "subscription-experience-data-types": "static-1.14873",
  "crm-record-cards-service-types": "static-1.3578",
  "location-customization-utils-lib": "static-1.9143",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5819",
  "signup-constants": "static-1.18779",
  "signup-ui-url-generator": "static-2.8006",
  "trials-service-types": "static-1.3869",
  "card-properties-lib": "static-1.44068",
  "commerce-subscription-lib": "static-1.37002",
  "crm-actions": "static-1.6285",
  "crm-cards-sdk": "static-1.43474",
  "customer-data-properties-shared-msw-handlers": "static-1.9199",
  "customer-data-tracking": "static-1.6851",
  "hs-resources": "static-1.114",
  "pulse": "static-1.526",
  "calling-global-api": "static-1.64383",
  "calling-internal-common": "static-1.31267",
  "calling-lifecycle-internal": "static-1.65765",
  "calling-lifecycle-messages": "static-1.58059",
  "commerce-products-lib": "static-1.9406",
  "conditional-properties-service-client": "static-1.3767",
  "crm-links": "static-1.6249",
  "external-options-client-types": "static-1.4128",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4193",
  "meetings-icalendar-utils-lib": "static-1.597",
  "multi-currency-client-types": "static-1.3661",
  "object-builder-ui-client": "static-1.48613",
  "pipeline-validation-client-types": "static-1.3935",
  "smart-property-lib": "static-1.6732",
  "tiered-pricing": "static-1.1125",
  "ui-addon-form-validation": "static-1.10953",
  "crm-pipelines-api-client-types": "static-1.4112",
  "ui-addon-opt": "static-4.8336",
  "campaign-roi-lib": "static-1.8982",
  "react-dnd-compat": "static-1.4585",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5368",
  "growth-onboarding-confetti": "static-1.3032",
  "growth-onboarding-next-action-utils": "static-1.1815",
  "onboarding-tours-utils": "static-1.592",
  "ui-shepherd-tracker": "static-1.7495",
  "academy-service-client": "static-1.3648",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39013",
  "FileManagerLib": "static-1.39154",
  "video-embed": "static-1.35640",
  "zustand": "static-1.74",
  "ui-coaching-tips": "static-1.28443",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11148",
  "video-data-lib": "static-1.34806",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23431",
  "ui-addon-emoji-picker": "static-1.9853",
  "EmailSignatureEditor": "static-1.24289",
  "viral-links-lib": "static-1.7021",
  "data-token-picker": "static-1.16340",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.190",
  "timezone-utils": "static-2.5210",
  "getting-started-shared-tasks-store": "static-1.17517",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7290",
  "customer-data-views-management": "static-1.25377",
  "framework-data-table": "static-2.11831",
  "marketing-platform-lib": "static-1.6817",
  "nudge-client-utils": "static-1.2479",
  "nudge-custom-ui-functions": "static-1.968",
  "app-users-service-client": "static-1.5559",
  "app-users-service-types": "static-1.4967",
  "mini-checkout-client": "static-1.26711",
  "onboarding-utils": "static-1.5318",
  "permissions-shared-i18n-strings-fe": "static-1.2044",
  "ui-coaching-tips-shared-config": "static-1.28428",
  "edison-service-client-types": "static-1.353",
  "crm_data": "static-4.91841",
  "customer-data-sidebar": "static-2.45909",
  "enrichment-properties-lib": "static-1.15850",
  "commerce-billing-lib": "static-1.18959",
  "commerce-shared-components-lib": "static-1.18426",
  "commerce-tools-ui-lib": "static-1.10271",
  "crm-fe-perf": "static-1.22868",
  "bend-plugin-pulse": "static-1.29",
  "directed-graph": "static-1.900",
  "event-emitter": "static-1.913",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31273",
  "shared-worker-versioning": "static-1.11003",
  "calling-usage-tracker": "static-1.6508",
  "voice-sms-access-library": "static-1.837",
  "commerce-permissions": "static-1.731",
  "products-iframe-lib": "static-1.7831",
  "products-ui-components-shared-msw-handlers": "static-1.10254",
  "data-agent-kit": "static-1.133",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9955",
  "policy-lib": "static-1.6738",
  "react-tinymce": "static-1.55134",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10018",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54260",
  "tinymce-plugins": "static-1.57374",
  "tinymce-themes": "static-1.56230",
  "breeze-engine-lib": "static-1.486",
  "onboarding-data-sync-lib": "static-1.1899",
  "growth-onboarding-next-action-components": "static-1.1843",
  "user-context-client": "static-1.4575",
  "audio-components": "static-1.5859",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36665",
  "urlinator": "static-1.4496",
  "video-components": "static-1.13151",
  "outpost": "static-1.4151",
  "growth-onboarding-feedback-components": "static-1.6548",
  "content-media-composition-data-lib": "static-1.12133",
  "content-media-compositions": "static-2.16140",
  "media-bridge-lib": "static-1.18862",
  "commerce-tours-lib": "static-1.6023",
  "growth-onboarding-reliability": "static-1.5046",
  "sales-checkout-service-client": "static-1.3605",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21606",
  "sales-email-signature-service-client": "static-1.3809",
  "ts-utils-lib": "static-1.138",
  "crm-export-dialog": "static-1.6264",
  "crm-index-associations-lib": "static-1.6404",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1878",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2236",
  "nudge-renderer-utils": "static-1.2555",
  "whisper-core-api": "static-1.6506",
  "InboxConnectUtils": "static-4.14711",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5420",
  "settings-content-modals": "static-1.45972",
  "crm_universal": "static-1.21941",
  "customer-data-email": "static-1.17968",
  "card-payment-highlight-lib": "static-1.37061",
  "card-subscription-highlight-lib": "static-1.39425",
  "commerce-contract-lib": "static-1.11912",
  "invoices-highlight-card-lib": "static-1.54601",
  "orders-highlight-card-lib": "static-1.21367",
  "products-highlight-card-lib": "static-1.17690",
  "quotes-highlight-card-lib": "static-1.71872",
  "crm-source-interpretation-lib": "static-1.5304",
  "utility-belt": "static-1.2502",
  "payments-enrollment-embed-lib": "static-1.22614",
  "stripe-embedded-components": "static-1.7436",
  "customer-data-rte": "static-1.32894",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5650",
  "payments-post-enroll-local-storage-lib": "static-1.5074",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37962",
  "calling-orchestration-schema": "static-1.35614",
  "sales-views-client-types": "static-1.4230",
  "hub-http-contrib": "static-1.3005",
  "interframe": "static-3.4726",
  "tinymce-data": "static-1.40345",
  "ui-addon-sales-email": "static-1.5176",
  "layout-dnd-components": "static-1.12371",
  "layout-dnd-utils": "static-1.11346",
  "ui-brand-identity-lib": "static-1.15108",
  "NamespacedHubStyle": "static-2.9032",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.21991",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1882",
  "checkout-sdk": "static-3.23554",
  "checkout-service-types": "static-1.3796",
  "company-details-components": "static-1.6162",
  "payment-method-components": "static-1.6877",
  "pricing-pages-ui-components": "static-1.13758",
  "quote-checkout-service-types": "static-1.3442",
  "upgrade-catalog-service-types": "static-1.3490",
  "access-control-lib": "static-1.10402",
  "EmailComponents": "static-1.54669",
  "EmailData": "static-1.53346",
  "redux-less": "static-2.9448",
  "sequences-lib": "static-1.7975",
  "ui-gdpr-components": "static-1.10313",
  "products-ui-components": "static-1.39925",
  "accounting-integrations-ui-components": "static-1.7003",
  "invoices-ui-lib": "static-1.54617",
  "commerce-products-api": "static-1.2231",
  "invoices-iframe-lib": "static-1.56675",
  "quotes-modal-lib": "static-1.102550",
  "quotes-ui-lib": "static-1.80593",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28162",
  "ContentData": "static-1.68327",
  "layout-data-lib": "static-1.9671",
  "hub-http-rxjs": "static-1.794",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3898",
  "billing-payments-client-types": "static-1.3956",
  "react-performance-metrics-lib": "static-1.524",
  "account-and-billing-fintech-outages": "static-3.18527",
  "pricing-pages-api": "static-1.13623",
  "ContentComponents": "static-2.71208",
  "marketing-contacts-lib": "static-1.9873",
  "marketing-email-service-types": "static-1.1896",
  "messaging-editing-lib": "static-1.46153",
  "messaging-usage-based-billing-components-lib": "static-1.1015",
  "automation-ui-source-apps": "static-1.18760",
  "automation-ui-types": "static-1.19678",
  "messaging-types-lib": "static-1.45890",
  "onboarding-settings-client": "static-1.4468",
  "sequences-client-types-lib": "static-1.7832",
  "commerce-tax-lib": "static-1.489",
  "price-books-api": "static-1.520",
  "price-books-components": "static-1.578",
  "property-description-translator": "static-1.3811",
  "ramp-editor": "static-1.59",
  "commerce-analytics-service-client": "static-1.3593",
  "totals-ui-components": "static-1.23491",
  "SalesContentIndexUI": "static-3.9186",
  "advanced-menus-core": "static-1.15069",
  "advanced-menus-lib": "static-1.12017",
  "ui-memberships-settings-lib": "static-1.33943",
  "segments-query-core": "static-1.1379",
  "demographics-service-types": "static-1.1618",
  "eligibility-engine-service-types": "static-1.3150",
  "automation-ui-ubb": "static-1.5594",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7304",
  "data-token-views": "static-1.16321",
  "forms-utils-lib": "static-1.12508",
  "payments-embed-points-lib": "static-1.12950",
  "simple-menus-core": "static-1.15068",
  "simple-menus-lib": "static-1.16585",
  "ui-addon-draggable-compat": "static-2.4220",
  "videoconference-integration-components": "static-1.6763",
  "marketing-contacts-client": "static-1.7483",
  "automation-applications-service-types": "static-1.3467",
  "automation-platform-service-types": "static-1.2568",
  "ContentEditorUI": "static-2.77010",
  "short-messages-app-service-client": "static-1.3947",
  "web-interactives-components": "static-1.13695",
  "web-interactives-data": "static-1.13696",
  "messaging-shared-utils-lib": "static-1.464",
  "messaging-user-info-utils-lib": "static-1.634",
  "email-portal-health-service-types": "static-1.942",
  "line-items-api": "static-1.632",
  "commerce-totals-service-types": "static-1.3788",
  "FireAlarmUi": "static-1.4483",
  "sales-templates-service-types-lib": "static-1.4138",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21614",
  "automation-ui-usage-tracking": "static-1.21077",
  "data-studio-ubb": "static-1.2609",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26934",
  "collaboration-sidebar": "static-1.57691",
  "content-management-data-lib": "static-1.5336",
  "copilot-plugins": "static-1.11009",
  "cta-picker": "static-1.36300",
  "customer-agent-discovery-components-lib": "static-1.2983",
  "editor-components": "static-1.13177",
  "editor-iframe-lib": "static-1.8349",
  "error-messaging-js": "static-1.5157",
  "FormsCommonComponents": "static-1.85739",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10611",
  "SharedLegalStrings": "static-1.1711",
  "smart-content-core": "static-1.42332",
  "smart-content-lib": "static-1.42985",
  "social-composer-lib": "static-1.58948",
  "structured-content-lib": "static-1.25090",
  "theme-previewer-lib": "static-1.53148",
  "tinymce-copilot": "static-1.16328",
  "xray-recommendation-lib": "static-1.7849",
  "automation-ui-routing": "static-1.21035",
  "sql-reporting-client-types": "static-1.5605",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42109",
  "campaigns-utils-lib": "static-1.3138",
  "reporting-enablement": "static-1.22784",
  "chatspot-widget-iframe": "static-1.21107",
  "collaboration-sidebar-common": "static-1.2488",
  "forms-ai-lib": "static-1.4257",
  "codemirror-dlb": "static-1.58569",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6395",
  "report-customization-components": "static-1.13058",
  "data-quality-ui-library": "static-1.12874",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.237",
  "reporting-insights-lib": "static-1.1633"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12135",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.464",
  "dashboard-client-types": "/dashboard-client-types/static-1.359",
  "data-fetching-client": "/data-fetching-client/static-1.9638",
  "foundations-components": "/foundations-components/static-1.7856",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.881",
  "foundations-theming": "/foundations-theming/static-1.4382",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7980",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11427",
  "I18n": "/I18n/static-7.1615",
  "jasmine-runner": "/jasmine-runner/static-1.6433",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12196",
  "quartz": "/quartz/static-1.6973",
  "react-dlb": "/react-dlb/static-1.78",
  "react-rhumb": "/react-rhumb/static-1.16634",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2824",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.55",
  "settings-ui-lib": "/settings-ui-lib/static-1.12486",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7065",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11115",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9510",
  "unified-auth": "/unified-auth/static-1.443",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.724",
  "usage-tracker": "/usage-tracker/static-1.7303",
  "usage-tracker-core": "/usage-tracker-core/static-1.7153",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8048",
  "hub-http": "/hub-http/static-1.6187",
  "integrations-lib": "/integrations-lib/static-1.16004",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19584",
  "property-management-iframe": "/property-management-iframe/static-1.13021",
  "quartz-config": "/quartz-config/static-1.751",
  "quartz-core": "/quartz-core/static-1.6192",
  "quartz-routing": "/quartz-routing/static-1.403",
  "quick-fetch": "/quick-fetch/static-1.3886",
  "react": "/react/static-7.185",
  "rpc-client-utils": "/rpc-client-utils/static-1.4616",
  "ts-schema": "/ts-schema/static-1.4048",
  "ui-universal-auth": "/ui-universal-auth/static-1.8929",
  "UIComponents": "/UIComponents/static-3.8374",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3374",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3250",
  "quartz-webpack": "/quartz-webpack/static-1.3197",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.51",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4125",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4823",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2098",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9394",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5314",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1743",
  "ui-fonts": "/ui-fonts/static-1.689",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2865",
  "foundations-theming-base": "/foundations-theming-base/static-1.3367",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.742",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3091",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4289",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8843",
  "ai-rendering-library": "/ai-rendering-library/static-1.9988",
  "chirp-fetch": "/chirp-fetch/static-1.1850",
  "connections-embed-lib": "/connections-embed-lib/static-1.923",
  "copilot-toolkit": "/copilot-toolkit/static-1.11036",
  "feedback-loader": "/feedback-loader/static-1.29227",
  "laboratory-lib": "/laboratory-lib/static-3.7124",
  "marketplace-embed": "/marketplace-embed/static-1.21975",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9480",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19540",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13755",
  "sanitize-text": "/sanitize-text/static-1.8108",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8663",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5717",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4989",
  "wootric-nps": "/wootric-nps/static-1.6949",
  "quartz-head": "/quartz-head/static-1.638",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4613",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4119",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2480",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.55",
  "cssUtils": "/cssUtils/static-1.782",
  "flux-actions": "/flux-actions/static-1.331",
  "HubStyle": "/HubStyle/static-2.11735",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10176",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10336",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7293",
  "icons": "/icons/static-2.644",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18117",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4480",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5339",
  "quartz-i18n": "/quartz-i18n/static-1.648",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.128",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.245",
  "fsm": "/fsm/static-1.3697",
  "customer-data-objects": "/customer-data-objects/static-1.7628",
  "property-translator": "/property-translator/static-1.5366",
  "hs-locale-management": "/hs-locale-management/static-1.54",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7894",
  "hs-promise-utils": "/hs-promise-utils/static-1.5558",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4841",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13419",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5564",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7748",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4437",
  "superstore": "/superstore/static-1.4731",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10114",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7824",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4622",
  "immutable-less": "/immutable-less/static-1.4614",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16991",
  "nav-meta": "/nav-meta/static-1.29544",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10211",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17934",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3810",
  "property-management-common": "/property-management-common/static-1.5309",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9023",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.648",
  "quartz-test": "/quartz-test/static-1.648",
  "quartz-tracking": "/quartz-tracking/static-1.352",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.26",
  "bender-build-tools": "/bender-build-tools/static-1.3151",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3560",
  "persist-promise": "/persist-promise/static-1.3667",
  "reference-resolvers": "/reference-resolvers/static-1.8135",
  "transmute": "/transmute/static-2.85",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21116",
  "ContentUtils": "/ContentUtils/static-1.68252",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12991",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2464",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39628",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13125",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14229",
  "ExportDialog": "/ExportDialog/static-6.10359",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41195",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.55",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.55",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.55",
  "ui-addon-teams": "/ui-addon-teams/static-1.21497",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "navigation-components": "/navigation-components/static-1.17907",
  "magpie-types": "/magpie-types/static-1.4996",
  "simple-logging-lib": "/simple-logging-lib/static-1.3014",
  "ai-studio-lib": "/ai-studio-lib/static-1.11498",
  "app-governance-lib": "/app-governance-lib/static-1.1431",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10475",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7962",
  "ui-product-approvals": "/ui-product-approvals/static-1.28028",
  "ui-tool-access": "/ui-tool-access/static-1.10115",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8698",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5720",
  "usage-tracker-public": "/usage-tracker-public/static-1.7114",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3891",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.300",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2978",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2671",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5037",
  "purchase-motions-components": "/purchase-motions-components/static-1.5816",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1510",
  "crm-component-utils": "/crm-component-utils/static-1.38986",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5841",
  "customer-data-properties": "/customer-data-properties/static-1.51420",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6845",
  "property-value-citations": "/property-value-citations/static-1.2034",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8060",
  "navigation-messaging": "/navigation-messaging/static-1.7234",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9870",
  "growth-payments-core": "/growth-payments-core/static-1.25268",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13565",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7214",
  "crm-message-bus": "/crm-message-bus/static-1.42892",
  "reporting-plugins": "/reporting-plugins/static-1.10255",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.55",
  "cms-field-types": "/cms-field-types/static-1.4777",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9792",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22063",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4684",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3979",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6750",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.944",
  "onboarding-tours": "/onboarding-tours/static-1.16526",
  "academy-common-lib": "/academy-common-lib/static-1.13689",
  "content-assistance-lib": "/content-assistance-lib/static-1.7694",
  "dashboard-lib": "/dashboard-lib/static-1.81385",
  "file-manager-components": "/file-manager-components/static-1.23514",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18399",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18139",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18131",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19766",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8663",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4734",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10976",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9014",
  "user-context": "/user-context/static-1.5068",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.686",
  "nest": "/nest/static-1.192",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10589",
  "framework-listing-lib": "/framework-listing-lib/static-2.28587",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30628",
  "apps-service-types": "/apps-service-types/static-1.3843",
  "oauth-service-types": "/oauth-service-types/static-1.4216",
  "onboarding-scopes": "/onboarding-scopes/static-1.6427",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4740",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7643",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14873",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3578",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9143",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5819",
  "signup-constants": "/signup-constants/static-1.18779",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8006",
  "trials-service-types": "/trials-service-types/static-1.3869",
  "card-properties-lib": "/card-properties-lib/static-1.44068",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37002",
  "crm-actions": "/crm-actions/static-1.6285",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43474",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9199",
  "customer-data-tracking": "/customer-data-tracking/static-1.6851",
  "hs-resources": "/hs-resources/static-1.114",
  "pulse": "/pulse/static-1.526",
  "calling-global-api": "/calling-global-api/static-1.64383",
  "calling-internal-common": "/calling-internal-common/static-1.31267",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65765",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58059",
  "commerce-products-lib": "/commerce-products-lib/static-1.9406",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3767",
  "crm-links": "/crm-links/static-1.6249",
  "external-options-client-types": "/external-options-client-types/static-1.4128",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4193",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.597",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3661",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48613",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3935",
  "smart-property-lib": "/smart-property-lib/static-1.6732",
  "tiered-pricing": "/tiered-pricing/static-1.1125",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10953",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4112",
  "ui-addon-opt": "/ui-addon-opt/static-4.8336",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8982",
  "react-dnd-compat": "/react-dnd-compat/static-1.4585",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5368",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3032",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1815",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.592",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7495",
  "academy-service-client": "/academy-service-client/static-1.3648",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39013",
  "FileManagerLib": "/FileManagerLib/static-1.39154",
  "video-embed": "/video-embed/static-1.35640",
  "zustand": "/zustand/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28443",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11148",
  "video-data-lib": "/video-data-lib/static-1.34806",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23431",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9853",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24289",
  "viral-links-lib": "/viral-links-lib/static-1.7021",
  "data-token-picker": "/data-token-picker/static-1.16340",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.190",
  "timezone-utils": "/timezone-utils/static-2.5210",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17517",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7290",
  "customer-data-views-management": "/customer-data-views-management/static-1.25377",
  "framework-data-table": "/framework-data-table/static-2.11831",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6817",
  "nudge-client-utils": "/nudge-client-utils/static-1.2479",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.968",
  "app-users-service-client": "/app-users-service-client/static-1.5559",
  "app-users-service-types": "/app-users-service-types/static-1.4967",
  "mini-checkout-client": "/mini-checkout-client/static-1.26711",
  "onboarding-utils": "/onboarding-utils/static-1.5318",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2044",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28428",
  "edison-service-client-types": "/edison-service-client-types/static-1.353",
  "crm_data": "/crm_data/static-4.91841",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45909",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15850",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18959",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18426",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10271",
  "crm-fe-perf": "/crm-fe-perf/static-1.22868",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.29",
  "directed-graph": "/directed-graph/static-1.900",
  "event-emitter": "/event-emitter/static-1.913",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31273",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11003",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6508",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.837",
  "commerce-permissions": "/commerce-permissions/static-1.731",
  "products-iframe-lib": "/products-iframe-lib/static-1.7831",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10254",
  "data-agent-kit": "/data-agent-kit/static-1.133",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9955",
  "policy-lib": "/policy-lib/static-1.6738",
  "react-tinymce": "/react-tinymce/static-1.55134",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10018",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54260",
  "tinymce-plugins": "/tinymce-plugins/static-1.57374",
  "tinymce-themes": "/tinymce-themes/static-1.56230",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.486",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1899",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1843",
  "user-context-client": "/user-context-client/static-1.4575",
  "audio-components": "/audio-components/static-1.5859",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36665",
  "urlinator": "/urlinator/static-1.4496",
  "video-components": "/video-components/static-1.13151",
  "outpost": "/outpost/static-1.4151",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6548",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12133",
  "content-media-compositions": "/content-media-compositions/static-2.16140",
  "media-bridge-lib": "/media-bridge-lib/static-1.18862",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6023",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5046",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3605",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21606",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3809",
  "ts-utils-lib": "/ts-utils-lib/static-1.138",
  "crm-export-dialog": "/crm-export-dialog/static-1.6264",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6404",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1878",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2236",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2555",
  "whisper-core-api": "/whisper-core-api/static-1.6506",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14711",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5420",
  "settings-content-modals": "/settings-content-modals/static-1.45972",
  "crm_universal": "/crm_universal/static-1.21941",
  "customer-data-email": "/customer-data-email/static-1.17968",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37061",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39425",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11912",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54601",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21367",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17690",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71872",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5304",
  "utility-belt": "/utility-belt/static-1.2502",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22614",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7436",
  "customer-data-rte": "/customer-data-rte/static-1.32894",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5650",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5074",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37962",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35614",
  "sales-views-client-types": "/sales-views-client-types/static-1.4230",
  "hub-http-contrib": "/hub-http-contrib/static-1.3005",
  "interframe": "/interframe/static-3.4726",
  "tinymce-data": "/tinymce-data/static-1.40345",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5176",
  "layout-dnd-components": "/layout-dnd-components/static-1.12371",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11346",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15108",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9032",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.21991",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1882",
  "checkout-sdk": "/checkout-sdk/static-3.23554",
  "checkout-service-types": "/checkout-service-types/static-1.3796",
  "company-details-components": "/company-details-components/static-1.6162",
  "payment-method-components": "/payment-method-components/static-1.6877",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13758",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3442",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3490",
  "access-control-lib": "/access-control-lib/static-1.10402",
  "EmailComponents": "/EmailComponents/static-1.54669",
  "EmailData": "/EmailData/static-1.53346",
  "redux-less": "/redux-less/static-2.9448",
  "sequences-lib": "/sequences-lib/static-1.7975",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10313",
  "products-ui-components": "/products-ui-components/static-1.39925",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7003",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54617",
  "commerce-products-api": "/commerce-products-api/static-1.2231",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56675",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102550",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80593",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28162",
  "ContentData": "/ContentData/static-1.68327",
  "layout-data-lib": "/layout-data-lib/static-1.9671",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.794",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3898",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3956",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.524",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18527",
  "pricing-pages-api": "/pricing-pages-api/static-1.13623",
  "ContentComponents": "/ContentComponents/static-2.71208",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9873",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1896",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46153",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1015",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18760",
  "automation-ui-types": "/automation-ui-types/static-1.19678",
  "messaging-types-lib": "/messaging-types-lib/static-1.45890",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4468",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7832",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.489",
  "price-books-api": "/price-books-api/static-1.520",
  "price-books-components": "/price-books-components/static-1.578",
  "property-description-translator": "/property-description-translator/static-1.3811",
  "ramp-editor": "/ramp-editor/static-1.59",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3593",
  "totals-ui-components": "/totals-ui-components/static-1.23491",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9186",
  "advanced-menus-core": "/advanced-menus-core/static-1.15069",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12017",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33943",
  "segments-query-core": "/segments-query-core/static-1.1379",
  "demographics-service-types": "/demographics-service-types/static-1.1618",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3150",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5594",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7304",
  "data-token-views": "/data-token-views/static-1.16321",
  "forms-utils-lib": "/forms-utils-lib/static-1.12508",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12950",
  "simple-menus-core": "/simple-menus-core/static-1.15068",
  "simple-menus-lib": "/simple-menus-lib/static-1.16585",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4220",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6763",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7483",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3467",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2568",
  "ContentEditorUI": "/ContentEditorUI/static-2.77010",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3947",
  "web-interactives-components": "/web-interactives-components/static-1.13695",
  "web-interactives-data": "/web-interactives-data/static-1.13696",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.464",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.634",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.942",
  "line-items-api": "/line-items-api/static-1.632",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3788",
  "FireAlarmUi": "/FireAlarmUi/static-1.4483",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4138",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21614",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21077",
  "data-studio-ubb": "/data-studio-ubb/static-1.2609",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26934",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57691",
  "content-management-data-lib": "/content-management-data-lib/static-1.5336",
  "copilot-plugins": "/copilot-plugins/static-1.11009",
  "cta-picker": "/cta-picker/static-1.36300",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2983",
  "editor-components": "/editor-components/static-1.13177",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8349",
  "error-messaging-js": "/error-messaging-js/static-1.5157",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85739",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10611",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1711",
  "smart-content-core": "/smart-content-core/static-1.42332",
  "smart-content-lib": "/smart-content-lib/static-1.42985",
  "social-composer-lib": "/social-composer-lib/static-1.58948",
  "structured-content-lib": "/structured-content-lib/static-1.25090",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53148",
  "tinymce-copilot": "/tinymce-copilot/static-1.16328",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7849",
  "automation-ui-routing": "/automation-ui-routing/static-1.21035",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5605",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42109",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3138",
  "reporting-enablement": "/reporting-enablement/static-1.22784",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21107",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2488",
  "forms-ai-lib": "/forms-ai-lib/static-1.4257",
  "codemirror-dlb": "/codemirror-dlb/static-1.58569",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6395",
  "report-customization-components": "/report-customization-components/static-1.13058",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12874",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.237",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1633"
}
};
